// frontend/src/utils/localStore.ts
export interface UserPreferences {
  theme: 'light' | 'dark' | 'neon' | 'pastel';
  lastModel: string;
  lastConversationId?: string;
}

// Sauvegarder les préférences utilisateur
export const saveUserPreferences = (prefs: UserPreferences): void => {
  localStorage.setItem('typia_preferences', JSON.stringify(prefs));
};

// Récupérer les préférences
export const getUserPreferences = (): UserPreferences | null => {
  const prefs = localStorage.getItem('typia_preferences');
  if (prefs) {
    try {
      return JSON.parse(prefs);
    } catch {
      return null;
    }
  }
  return null;
};

// Sauvegarder la dernière conversation active
export const saveLastConversationId = (id?: string): void => {
  const prefs = getUserPreferences() || {
    theme: 'light',
    lastModel: '',
  };
  
  saveUserPreferences({
    ...prefs,
    lastConversationId: id
  });
};